import { Outlet } from 'react-router-dom';

function ProductsRootLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default ProductsRootLayout;
